import React from 'react';
import { Link, Outlet, useOutletContext } from 'react-router-dom';
import { Alert, Space } from 'antd';

export default function FE5() {
  const [buffer] = useOutletContext();

  return (
    <Space
      direction="vertical"
      align="center"
      style={{ width: '100%' }}
    >
      <Link to={{ pathname: '/FE5', state: { buffer } }}>
        <Alert
          message="FE5: Thracia 776"
          type="info"
        />
      </Link>
      <Outlet context={[buffer]} />
    </Space>
  );
}
